import { IntlShape } from 'react-intl';
import { DishId, DishForView } from './Dish';
import getLocalized, { Localized } from '../../locales/Localized';
import { getLocalizedString, getLocalizedStringOrUndefined } from '../../locales';

export type CategoryId = string;

export interface CategoryState {
  id: CategoryId;
  name: Localized<string>;
  subtitle: Localized<string>;
  dishList: DishId[];
}

export default class Category {
  private state: CategoryState;

  constructor(state: CategoryState) {
    this.state = {
      id: state.id,
      name: (state.name || {}),
      subtitle: (state.subtitle || {}),
      dishList: (state.dishList || []),
    }
  }

  public static fromState(state: CategoryState): Category {
    return new Category(state);
  }

  public getId(): CategoryId {
    return this.state.id;
  }

  public getName(locale: string): string | undefined {
    return getLocalized(this.state.name, locale);
  }

  public getSubtitle(locale: string): string | undefined {
    return getLocalized(this.state.subtitle, locale);
  }

  public getDishList(): DishId[] {
    return this.state.dishList;
  }

  public getForView(intl: IntlShape, getDishFun: ((id: DishId) => DishForView)): CategoryForView {
    return new CategoryForView({
      id: this.state.id,
      name: getLocalizedString(intl, this.state.name),
      subtitle: getLocalizedStringOrUndefined(intl, this.state.subtitle),
      dishes: this.state.dishList.map(getDishFun),
    });
  }
}

interface CategoryForViewProps {
  id: CategoryId;
  name: string;
  subtitle?: string;
  dishes: DishForView[];
}

export class CategoryForView {
  private state: CategoryForViewProps;

  constructor(props: CategoryForViewProps) {
    this.state = {
      id: props.id,
      name: props.name,
      subtitle: props.subtitle,
      dishes: props.dishes,
    }
  }

  public getId(): CategoryId {
    return this.state.id;
  }

  public getName(): string {
    return this.state.name;
  }

  public getSubtitle(): string | undefined {
    return this.state.subtitle;
  }

  public getDishes(): DishForView[] {
    return this.state.dishes;
  }

}
